module.exports = __webpack_public_path__ + "img/stage-6-motion.ec986b88.png";